import TemplateFormFieldModel from "../../../../../shared/models/templating/api/TemplateFormFieldModel";
import {
    getDefaultFormFieldsByAssistantType,
    getDefaultFormFieldsByPosName
} from "../../../../../shared/constants/sparkConstants/defaultFormFieldsByAssistantType";

const uniqueStrings = (values: string[]): string[] => Array.from(new Set(values.filter(Boolean)));

export const shouldApplyDefaultLocationFields = (
    locationAppFieldCount: number,
    selectedFieldCount: number,
    hasCommonApp: boolean
): boolean => locationAppFieldCount === 0 && selectedFieldCount === 0 && !hasCommonApp;

export const getRecommendedLocationFieldIdentifiers = (
    assistantType: string,
    posName?: string
): string[] => {
    const assistantFields = getDefaultFormFieldsByAssistantType(assistantType);
    const posFields = assistantType === "ai-ordering" && posName
        ? getDefaultFormFieldsByPosName(posName)
        : [];

    return uniqueStrings([...assistantFields, ...posFields]);
};

const isRecommendedField = (
    field: TemplateFormFieldModel,
    recommendedIdentifiers: Set<string>
): boolean => field.associatedVariable
    ? recommendedIdentifiers.has(field.associatedVariable)
    : !!field.title && recommendedIdentifiers.has(field.title);

const fieldsMatch = (left: TemplateFormFieldModel, right: TemplateFormFieldModel): boolean => {
    if (left.associatedVariable && right.associatedVariable) {
        return left.associatedVariable === right.associatedVariable;
    }

    if (left.id && right.id && left.id === right.id) {
        return true;
    }

    return !!left.title && !!right.title && left.title === right.title;
};

export const getAvailableRecommendedLocationFields = (
    sections: Array<{ templateFormFields?: TemplateFormFieldModel[] }>,
    recommendedIdentifiers: string[]
): TemplateFormFieldModel[] => {
    const identifierSet = new Set(recommendedIdentifiers);
    const matchingFields = sections
        .flatMap(section => section.templateFormFields || [])
        .filter(field => isRecommendedField(field, identifierSet));

    return matchingFields.filter((field, index) => (
        matchingFields.findIndex(candidate => fieldsMatch(candidate, field)) === index
    ));
};

export const selectRecommendedLocationFields = (
    selectedFields: TemplateFormFieldModel[],
    availableRecommendedFields: TemplateFormFieldModel[]
): TemplateFormFieldModel[] => {
    const additions = availableRecommendedFields.filter(recommendedField => (
        !selectedFields.some(selectedField => fieldsMatch(selectedField, recommendedField))
    ));

    return [...selectedFields, ...additions];
};
